import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { ComponentProps, forwardRef } from 'react';

import useLoggedUser from '../../../../../hooks/use-logged-user';
import NoImage from '../../../no-image-placeholder';

import Trans from 'next-translate/Trans';
import BPImage from '../../image';

type TProductCard = {
  sku: TProductListItem['sku'];
  car: {
    brand: string;
    model: string;
    version: string;
  };
  part: TProductListItem['part'];
  reference: TProductListItem['reference'];
  pricing: TProductListItem['pricing'];
  main_image: TProductListItem['main_image'];
  warranty?: TProductDetail['warranty'];
  showSku?: boolean;
};

type AnchorProps = TProductCard & {
  as?: 'a';
} & ComponentProps<'a'>;

type DivProps = TProductCard & {
  as?: 'div';
} & ComponentProps<'div'>;

const ProductCard = forwardRef<
  HTMLAnchorElement | HTMLDivElement,
  DivProps | AnchorProps
>(
  (
    {
      as: Component = 'div',
      sku,
      car,
      part,
      reference,
      pricing,
      main_image,
      warranty,
      showSku = false,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation();
    const user = useLoggedUser();
    const isResaleer = user?.staff.company_type == 'supplier';
    return (
      <a
        ref={ref}
        className={cx(
          'gtm_product_impressions',
          //classes.productCard,
          'grid',
          'relative',
          //'relative flex justify-start items-start',
          'h-full w-full mx-auto',
          'hover:bg-brand-10 bg-white p-2 boder-white shadow-[0px_0px_8px_0px_rgba(0,0,0,0.1)]'
        )}
        {...props}
      >
        <div className="relative w-full flex flex-col h-full justify-start items-start gap-2">
          <div className="relative aspect-video h-auto shrink-0 flex w-full">
            <BPImage
              src={
                main_image ||
                `${process.env.PUBLIC_PREFIX}/svg/placeholder.svg`
              }
              alt={`${sku} main image`}
              fill
              style={{
                objectFit: 'cover',
                objectPosition: 'center',
              }}
              key={sku}
              priority={false}
            />
          </div>
          <div className="relative w-full h-full flex flex-col justify-between items-start gap-2">
            {showSku &&
              <span className="font-bold text-sm line-clamp-1 text-neutral-70">
                {sku}
              </span>}
            <span className="font-bold text-base line-clamp-1">
              {part}
            </span>
            <span className="text-sm line-clamp-1">
              Ref. {reference || '-'}
            </span>
            {isResaleer ? (
              <div className="block text-left flex items-end justify-between">
                <small className="text-red-100 mb-1">
                  {t('product:resale_price')}
                </small>
                <strong className="text-right">
                  {pricing?.price_final_printable ||
                    t('product:price_on_request')}
                </strong>
              </div>
            ) : (
              <strong className="block text-left flex items-end justify-start">
                {pricing?.price_final_printable ? (
                  <div>
                    <span className="font-extrabold">
                      {pricing?.price_final_printable}
                    </span>
                    <div className="text-xs text-green-100">
                      <Trans
                        i18nKey={`product:checklist.vat_shipping_${pricing.price_message}`}
                        components={{ b: <b /> }}
                      />
                    </div>
                  </div>
                ) : (
                  t('product:price_on_request')
                )}
              </strong>
            )}
          </div>
        </div>
      </a>
    );
  }
);

ProductCard.displayName = 'ProductCard';

export default ProductCard;
